const BASE_API_URL = 'https://script.google.com';
const BASE_NOCODE_API_URL = 'https://v1.nocodeapi.com';

// export const dropdownDataUrl = BASE_API_URL + '/macros/s/AKfycbxUlfqIEFFv-bfmjzz1htGOfYxaKGivmjrgiqgwlvo9DBc4pT0_OMFVCz0A9P6S7-Ys/exec';

// export const dropdownDataUrl ="https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorWeb/get_dropdown_sheet";
export const dropdownDataUrl ="https://central-device-apis.el.r.appspot.com/api/subjectList/get_dropdown_data";
export const storeDataUrl = BASE_NOCODE_API_URL + '/registrationformdata/google_sheets/MBuXKmMYnKyzRwEr';